import { useState } from 'react';

export function useAutosuggest() {
  const [isSearching, setIsSearching] = useState(false);

  const handleOpenSuggest = (isOpen: boolean) => {
    setIsSearching(isOpen);
  };

  return { isSearching, handleOpenSuggest };
}

export function getHighlightedText(target: string, query: string) {
  if (query !== '' && target.includes(query)) {
    const parts = target.split(new RegExp(`(${escapeRegExp(query)})`, 'gi'));

    return (
      <>
        {parts.map((part, index) =>
          part.toLowerCase() === query.toLowerCase() ? <strong key={index}>{part}</strong> : part,
        )}
      </>
    );
  }

  return target;
}

function escapeRegExp(text: string) {
  return text.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
}
